// LocationService.js
import ApiService from "./apiService.mjs";

const LocationService = {
  /**
   * Search for cities based on search term
   * @param {string} query - Search term
   * @returns {Promise} - List of matching cities
   */
  searchCities: async (query) => {
    if (!query || query.length < 2) return [];
    
    const response = await ApiService.get('/cities/search', 
      {
      params: { query },
      withCredentials: true
    });
    return response.data;
  },
  
  /**
   * Get detailed information about a location
   * @param {string} city - City name
   * @param {string} country - Country name
   * @returns {Promise} - Location details including currency
   */
  getLocationDetails: async (city, country) => {
    const response = await ApiService.get('', {
      params: { city, country },
      withCredentials: true
    });
    return response.data;
  }
};

export default LocationService;

